import { Routes } from "@/router/types";
import { RouteConfig } from "vue-router";

export const bevollmaechtigte = (): Array<RouteConfig> => [
  {
    path: "/mvp/bevollmaechtigte",
    name: Routes.BEVOLLMAECHTIGTE,
    component: () => import("@/views/settings/Bevollmaechtigte.vue"),
    meta: {
      authorization: {
        require: true
      }
    }
  }
];
